var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.58586 9.00008L0.292969 1.70718L1.70718 0.292969L10.4143 9.00008L1.70718 17.7072L0.292969 16.293L7.58586 9.00008Z","fill":"#8F8F92"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }